import { apiUrl, cancellableRequest } from 'src/services/api.js';

export const QuickResponsesService = {
  ban(vacancyId) {
    const data = { vacancy_id: vacancyId };

    return cancellableRequest({
      method: 'post',
      url: `${apiUrl}/user_vacancy_bans`,
      data,
    });
  },
  respond(vacancyId) {
    const data = { vacancy_id: vacancyId };

    return cancellableRequest({
      method: 'post',
      url: `${apiUrl}/quick_responses`,
      data,
    });
  },
  sendFeedback(params) {
    return cancellableRequest({
      method: 'post',
      url: `${apiUrl}/feedbacks`,
      data: params,
    });
  },
};
